import React from "react";
import { Card } from "../common/Card";

type ItemDetail = {
  label: string;
  value: string;
  key?: string;
};

type Rating = {
  stars: number;
  percentage: number;
  count?: number;
};

interface OverallCardProps {
  title: string;
  icon: string;
  iconColor: string;
  arrowIcon: string;
  details: ItemDetail[];
  ratings: Rating[];
  className?: string;
}

const OverallCard: React.FC<OverallCardProps> = ({
  title,
  icon,
  iconColor,
  arrowIcon,
  details,
  ratings,
  className = "",
}) => {
  console.log("details", details);
  return (
    <Card
      className={`rounded-[24px] mb-6 border-[1px] border-[#FFFFFFCC] ${className}`}
      style={{
        boxShadow:
          "0px 2px 4px 0px #0000000D, 0px 5px 10px 0px #0000000D, 0px 0px 10px 0px #0000000D, 0px 22px 20px 0px #00000014, 0px 8.8px 8.8px 0px #00000008, inset 2px 2px 2px 0px #0000001A",
      }}
    >
      <div className="p-6">
        <div className="flex items-start">
          <img src={icon} className="h-[64px] w-[64px] mr-4" />
          <div className="flex-grow">
            <h3 className="text-[24px] nunito-medium mb-4 text-[#404040]">
              {title}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* First column of details */}
              {details.length > 0 && (
                <div>
                  {details
                    .filter((_, index) => index % 2 === 0)
                    .map((detail, index) => (
                      <div key={index} className="mb-4">
                        <p className="flex justify-start gap-3">
                          <img src={arrowIcon} className="w-[24px] h-[24px]" />

                          {detail.key === "activeExpertsCount" ? (
                            <div className="flex items-start gap-2 flex-col w-48">
                              <span className="min-w-32 text-[#0A0A0A] text-[16px] nunito-regular">
                                {detail.label}
                              </span>
                              <p className="text-[#919191] text-[11px]">
                                (completed atleast 1 session in the selected
                                timeframe)
                              </p>
                            </div>
                          ) : (
                            <span className="min-w-48 text-[#0A0A0A] text-[16px] w-48 nunito-regular">
                              {detail.label}
                            </span>
                          )}

                          <span className="text-[#404040]   text-[16px] nunito-bold">
                            {detail.value}
                          </span>
                        </p>
                      </div>
                    ))}
                </div>
              )}

              {/* Second column of details */}
              {details.length > 1 && (
                <div>
                  {details
                    .filter((_, index) => index % 2 === 1)
                    .map((detail, index) => (
                      <p key={index} className="flex justify-start gap-3 mb-5">
                        <img src={arrowIcon} className="w-[24px] h-[24px]" />
                        <span className="min-w-[220px] text-[#0A0A0A] text-[16px] nunito-regular">
                          {detail.label}
                        </span>
                        <span className="text-[#404040] text-[16px] nunito-bold">
                          {detail.value}
                        </span>
                      </p>
                    ))}
                </div>
              )}

              {/* Ratings column */}
              <div className="mt-[-50px]">
                <div className="mb-3">
                  <div className="flex items-center justify-between gap-4">
                    <h3 className="text-[16px] nunito-regular text-[#0A0A0A]">
                      {(title === "Expert Summary")
                        ? "Expert Rating Details"
                        : (title === "Customer Summary")
                        ? "Customer Rating Details"
                        : (title === "Experts")
                      }
                    </h3>
                    <div className="flex items-center gap-2">
                      <div
                        className={`w-[12px] h-[12px] rounded-full ${iconColor}`}
                      />
                      <span className="text-[#0A0A0A] text-[12px] nunito-regular">
                        Stars
                      </span>
                    </div>
                  </div>
                  <div className="border-b-2 border-[#EBEBEB]"></div>
                </div>{" "}
                <div className="space-y-1">
                  {ratings.map((rating, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-4 text-start"
                    >
                      <span className="min-w-[40px]  nunito-semibold text-[#2B2B2B] text-justify">
                        {rating.stars}(
                        {(() => {
                          const count = rating.count ?? 0;
                          return count >= 1 && count <= 9 ? `0${count}` : count;
                        })()}
                        )
                      </span>
                      <div className="flex-1 h-[10px] bg-gray-200 rounded-full overflow-hidden">
                        <div
                          className={`h-[10px] ${iconColor} rounded-full`}
                          style={{ width: `${rating.percentage}%` }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default OverallCard;
